import { Pipe, PipeTransform } from '@angular/core';
import { formatSeaweedPath } from './util';
import { AppRootContext } from '../bootstrap';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | teamLogoUrl
 * Example:
 *   {{ teamLogo | teamLogoUrl: 180 }}
 *   formats to: 1024
 */
@Pipe({ name: 'teamLogoUrl' })
export class TeamLogoUrlPipe implements PipeTransform {

    constructor(private appRootContext: AppRootContext) {}

    transform(logo: string): string {
        if (!logo) {
            logo = 'team_logo_default.png';
        }
        if (this.appRootContext.globalInfo.config.isIndependent) {
            if (logo === 'team_logo_default.png') {
                return '/image/' + logo;
            } else {
                return this.appRootContext.globalInfo.config.box.logoUrl + formatSeaweedPath(logo, 180, 180);
            }
        } else {
            return this.appRootContext.globalInfo.config.box.logoUrl + logo;
        }
    }
}
